import React from 'react';
import { Link } from 'react-router-dom';
import { FaGlobe, FaMobileAlt, FaStore, FaShoppingCart, FaArrowRight, FaCheck } from 'react-icons/fa';
import './Home.css';

const services = [
  {
    icon: <FaGlobe />,
    title: 'Application Web',
    desc: 'Applications web performantes et sur mesure pour digitaliser votre activité.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Application Mobile',
    desc: 'Applications Android & iOS natives ou hybrides pour toucher vos clients partout.',
  },
  {
    icon: <FaStore />,
    title: 'Site Vitrine',
    desc: 'Sites web modernes et optimisés SEO pour présenter votre entreprise.',
  },
  {
    icon: <FaShoppingCart />,
    title: 'Site E-commerce',
    desc: 'Boutiques en ligne performantes pour vendre vos produits 24h/24.',
  },
];

const stats = [
  { number: '50+', label: 'Projets réalisés' },
  { number: '100%', label: 'Clients satisfaits' },
  { number: '5+', label: "Années d'expérience" },
  { number: '24/7', label: 'Support réactif' },
];

const Home = () => {
  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg-effects">
          <div className="hero-orb hero-orb-1"></div>
          <div className="hero-orb hero-orb-2"></div>
        </div>
        <div className="container hero-content">
          <div className="hero-badge">Développeur Web & Mobile - Hérault</div>
          <h1 className="hero-title">
            Création de <span className="gradient-text">sites web</span> &{' '}
            <span className="gradient-text">applications mobiles</span> sur mesure
          </h1>
          <p className="hero-subtitle">
            AGKG Créations conçoit des solutions digitales performantes pour les entreprises et les particuliers.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn btn-primary">
              Demander un devis <FaArrowRight />
            </Link>
            <Link to="/services" className="btn btn-secondary">
              Nos services
            </Link>
          </div>
          <div className="hero-trust">
            <FaCheck className="hero-trust-icon" />
            <span>Devis gratuit et sans engagement</span>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section home-services">
        <div className="container">
          <h2 className="section-title">
            Nos <span>expertises</span>
          </h2>
          <p className="section-subtitle">
            Des solutions digitales complètes pour développer votre présence en ligne
          </p>
          <div className="services-grid">
            {services.map((service, index) => (
              <Link to="/services" key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <span className="service-link">
                  En savoir plus <FaArrowRight />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section home-stats">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number gradient-text">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section home-cta">
        <div className="container">
          <div className="cta-box">
            <h2>Un projet en tête ?</h2>
            <p>
              Discutons de votre projet et trouvons ensemble la meilleure solution
              pour atteindre vos objectifs.
            </p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">
                Me contacter <FaArrowRight />
              </Link>
              <a href="mailto:contact@agkgcreations.fr" className="btn btn-secondary">
                contact@agkgcreations.fr
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
